import { breadcrumbSchema } from "@/lib/schema";
import { STATS_TEXT } from "@/lib/stats";
import { createFileRoute } from "@tanstack/react-router";
import { SiteLayout } from "@/components/site/Layout";
import { Section, SectionEyebrow } from "@/components/site/Section";
import { CTABanner } from "@/components/site/CTABanner";
import { StatsBand } from "@/components/site/StatsBand";
import { ReviewsWidget } from "@/components/site/ReviewsWidget";
import { DirectAnswer, FAQSection, faqSchema } from "@/components/site/AnswerBlock";
import { RESULTS_ANSWER, RESULTS_FAQS } from "@/lib/aeo";
import { ResultsDisclaimer } from "@/components/site/ResultsDisclaimer";

export const Route = createFileRoute("/results")({
  head: () => ({
    meta: [
      { title: "KCN Results - Production, Splits and Agent Outcomes" },
      {
        name: "description",
        content:
          `What the KCN real estate team commission split means for real estate agent net income: 3,000+ transactions and $1B+ in 2025 volume across ${STATS_TEXT.markets} markets.`,
      },
      { property: "og:title", content: "Results & Reviews - KCN" },
      {
        property: "og:description",
        content:
          "The numbers and the voices behind the Kristan Cole Network.",
      },
      { property: "og:url", content: "https://joinkcn.com/results" },
    ],
    links: [{ rel: "canonical", href: "https://joinkcn.com/results" }],
    scripts: [
      breadcrumbSchema([{ name: "Results", path: "/results" }]),faqSchema(RESULTS_FAQS, "https://joinkcn.com/results")],
  }),
  component: ResultsPage,
});

function ResultsPage() {
  return (
    <SiteLayout>
      <section className="pt-36 pb-14 border-b border-border">
        <div className="container-edge">
          <p className="eyebrow mb-6">The Receipts</p>
          <h1 className="headline-xl max-w-5xl">
            Results that compound.
            <br />
            <span className="serif-italic text-primary">Voices that confirm.</span>
          </h1>
        </div>
      </section>

      <Section tone="dark" className="py-10 md:py-14 lg:py-14">
        <StatsBand />
        <ResultsDisclaimer />
      </Section>

      <Section tone="darker">
        <div className="grid lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-7">
            <SectionEyebrow>What people say</SectionEyebrow>
            <h2 className="headline-lg">
              From agents on the team and clients we've served.
            </h2>
          </div>
        </div>
        <ReviewsWidget />
      </Section>

      <DirectAnswer question={RESULTS_ANSWER.question} answer={RESULTS_ANSWER.answer} tone="cream" />

      <FAQSection
        faqs={RESULTS_FAQS}
        eyebrow="Questions about the numbers"
        heading="What the results mean for you."
        disclaimerQuestions={["Do agents actually grow after joining KCN?"]}
      />

      <CTABanner cta="roundtable" />
    </SiteLayout>
  );
}
